<script setup lang="ts">
import { getCurrentInstance } from 'vue'

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  link: {
    type: String,
    required: true,
  },
  arrow: {
    type: Boolean,
    default: false,
  },
  primary: {
    type: Boolean,
    default: false,
  },
  slide: {
    type: Boolean,
    default: false,
  },
  external: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String,
    default: 'default',
  },
})

const instance = getCurrentInstance()
const nuxtLink = instance?.appContext.components?.NuxtLink
</script>

<template>
  <component
    :is="!external && nuxtLink ? nuxtLink : 'a'"
    v-bind="!external && nuxtLink ? { to: link } : { href: link }"
    :class="[
      'button',
      { primary: primary },
      { slide: slide },
      { underline: variant === 'underline' },
    ]">
    {{ label }}
    <svg
      v-if="arrow"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="2.5"
      stroke="currentColor"
      class="size-6">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
    </svg>
  </component>
</template>

<style scoped>
.button {
  display: flex;
  border: none;
  padding: 0rem 3rem;
  height: 44px;
  min-width: 200px;
  color: var(--text-color);
  background-color: var(--background-color);
  border-radius: 25px;
  outline: 1px solid var(--background-reverse);
  font-family: var(--title-font);
  font-weight: var(--font-bold);
  cursor: pointer;
  transition-duration: 0.2s;
  align-self: center;
  justify-content: center;
  align-items: center;
  min-height: 44px;
  font-size: 0.9rem;
  text-decoration: none;
  gap: 0.5rem;
}

.button:hover {
  transition-duration: 0.3s;
}

svg {
  height: 16px;
  width: 16px;
}

.button:hover svg {
  animation: bounceRight 0.4s ease-in-out forwards;
}

@keyframes bounceRight {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(1rem);
  }
}

.primary {
  background-color: var(--primary-color);
  color: var(--white);
  border: none;
  outline: 1px solid var(--primary-color);
}

.slide {
  transition-duration: 0.4s;
  transition:
    color 0.3s ease,
    background-position 0.3s ease;
  background-size: 210% 100%;
  background-position: 98% 0;
  background-image: linear-gradient(
    to left,
    var(--transparent) 50%,
    var(--background-reverse) 50%
  );
}

.slide:hover {
  background-position: 0 0;
  color: var(--background-color);
  transition: all 0.3s ease-out;
  outline: 1.5px solid var(--background-color);
}

.underline {
  min-width: 0;
  min-height: 0;
  height: auto;
  padding: 0;
  border-radius: 0;
  background: transparent;
  outline: none;
  align-self: auto;
  text-decoration: underline;
  justify-content: flex-start;
}

@media screen and (max-width: 768px) {
  .button:not(.underline) {
    width: 100%;
  }
}
</style>
